import * as React from 'react';
import { PanelTitle } from './PanelTitle';
import { CONSTANTS } from '../../assets/UIConstants';

interface Props {
    width?: string | number;
    height?: string | number;
    title?: string;
    iconColor?: string;
    iconBorderColor?: string;
    icon?: React.ComponentClass;
    style?: React.CSSProperties;
    id?: string;
    popoverTitle?: string;
    popoverBody?: string | JSX.Element;
}

export class Panel extends React.Component<Props, {}> {

    private style: React.CSSProperties = {
        container: {
            border: '2px solid ' + CONSTANTS.COLORS.BORDER_GREY,
            borderRadius: '10px',
            backgroundColor: CONSTANTS.COLORS.WHITE,
            display: 'flex',
            flexGrow: CONSTANTS.FLEX_GROW.ONE,
            height: '100%',
            boxSizing: 'border-box',
            boxShadow: CONSTANTS.BOX_SHADOW.PANEL,
            flexDirection: 'column',
            ...this.props.style, 
        },
        content: {
            display: CONSTANTS.DISPLAY.FLEX,
            flexGrow: CONSTANTS.FLEX_GROW.ONE
        },
        panel: {
            width: this.props.width,
            height: this.props.height,
            margin: 10
        }
    };

    public render(): JSX.Element {
        return (
            <div id={this.props.id} style={this.style.panel}>
                <div style={this.style.container}>
                    {this.props.title &&
                    <PanelTitle
                        title={this.props.title}
                        icon={this.props.icon}
                        iconBorderColor={this.props.iconBorderColor}
                        iconColor={this.props.iconColor}
                        popoverTitle={this.props.popoverTitle}
                        popoverBody={this.props.popoverBody}
                    />
                    }
                    <div style={this.style.content}>
                        {this.props.children}
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/components/Panel.tsx